// @react/hooks/useAffiliateCampaign.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { affiliateCampaignStore } from '@core/stores';

/**
 * React hook for Campaign operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useAffiliateCampaign } from '@react/hooks';
 *
 * const CampaignList = observer(() => {
 *   const store = useAffiliateCampaign();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useAffiliateCampaign() {
  return affiliateCampaignStore;
}
